import { render, staticRenderFns } from "./StatusNumere.vue?vue&type=template&id=cc2dc8c0&scoped=true&"
import script from "./StatusNumere.vue?vue&type=script&lang=js&"
export * from "./StatusNumere.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc2dc8c0",
  null
  
)

export default component.exports
import {QLinearProgress} from 'quasar'
component.options.components = Object.assign({QLinearProgress}, component.options.components || {})
